import React from "react";

import Header from "./Components/Header";
import Introduction from "./Components/Introduction";
import About from "./Components/About";
import Services from "./Components/Services";
import Rdv from "./Components/rdv";
import ReviewContent from "./Components/Reviews";
import Legal from "./Components/Legal";

// =======================================================
// App as Javascript function
// =======================================================
function App() {
  return (
    <div className="App">
      <Header />
      <Introduction />
      <About />
      <Services />
      <Rdv />
      <ReviewContent />
      <Legal />
    </div>
  );
}

// =======================================================
export default App;
